import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackNavClick } from '../../lib/analytics';
import { RESTAURANT_SIGNUP_MAILTO } from '../../lib/restaurantSignup';

const Footer = () => {
  const handleClick = (target) => {
    trackNavClick({ target, location: 'footer' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col gap-4 rounded-2xl border border-emerald-800 bg-emerald-950/60 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-4">
            <div className="rounded-xl bg-emerald-600/20 p-3 text-2xl text-emerald-400"><SafeIcon icon={FiIcons.FiCoffee} /></div>
            <div>
              <p className="text-lg font-bold text-white">Dein Restaurant fehlt?</p>
              <p className="text-sm text-gray-400">Melde dich – wir nehmen deinen Mittagstisch auf und zeigen ihn jeden Tag aktuell auf SchleiShare.</p>
            </div>
          </div>
          <a href={RESTAURANT_SIGNUP_MAILTO} onClick={() => handleClick('Restaurant melden')} className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-emerald-500 px-5 py-3 text-sm font-bold text-gray-950 transition-colors hover:bg-emerald-400">
            <SafeIcon icon={FiIcons.FiMail} /> Restaurant melden
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 lg:col-span-1">
            <Link to="/" onClick={() => handleClick('Home')} className="flex items-center gap-2 mb-6">
              <SafeIcon icon={FiIcons.FiHeart} className="text-emerald-500 text-2xl" />
              <span className="font-bold text-xl text-white tracking-tight">Schlei<span className="text-emerald-500">Share</span></span>
            </Link>
            <p className="text-sm leading-relaxed">
              Die lokale Plattform gegen Lebensmittelverschwendung in Süderbrarup, Kappeln und der gesamten Schlei-Region.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Plattform</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/feed" onClick={() => handleClick('Feed')} className="hover:text-emerald-500 transition-colors">Alle Angebote</Link></li>
              <li><Link to="/brochures" onClick={() => handleClick('Brochures')} className="hover:text-emerald-500 transition-colors">Prospekte</Link></li>
              <li><Link to="/add" onClick={() => handleClick('AddFood')} className="hover:text-emerald-500 transition-colors">Essen anbieten</Link></li>
              <li><Link to="/leaderboard" onClick={() => handleClick('Leaderboard')} className="hover:text-emerald-500 transition-colors">Leaderboard</Link></li>
              <li><Link to="/media" onClick={() => handleClick('Media')} className="hover:text-emerald-400 transition-colors font-bold text-emerald-400">Teile SchleiShare</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Rechtliches</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/impressum" onClick={() => handleClick('Impressum')} className="hover:text-emerald-500 transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" onClick={() => handleClick('Datenschutz')} className="hover:text-emerald-500 transition-colors">Datenschutz</Link></li>
              <li><Link to="/datenschutz-center" onClick={() => handleClick('Datenschutz-Center')} className="font-bold text-emerald-400 hover:text-emerald-300 transition-colors">Datenschutz-Center</Link></li>
              <li><Link to="/nutzungsbedingungen" onClick={() => handleClick('Nutzungsbedingungen')} className="hover:text-emerald-500 transition-colors">Nutzungsbedingungen</Link></li>
              <li><Link to="/hygiene-richtlinien" onClick={() => handleClick('Hygiene-Richtlinien')} className="hover:text-emerald-500 transition-colors">Hygiene-Richtlinien</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Kontakt & Support</h4>
            <p className="text-sm mb-4">Fragen oder Feedback? Schreib uns!</p>
            <a href="mailto:hallo@schleishare.de" onClick={() => handleClick('Email')} className="flex items-center gap-2 text-emerald-500 hover:text-emerald-400 font-bold transition-colors mb-6">
              <SafeIcon icon={FiIcons.FiMail} /> hallo@schleishare.de
            </a>
            
            <div className="mt-4 pt-4 border-t border-gray-800">
              <p className="text-xs mb-3 text-gray-500 uppercase tracking-widest font-bold">Unterstütze uns</p>
              <a href="https://www.buymeacoffee.com/schleishare" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-90 transition-opacity">
                <img src="https://img.buymeacoffee.com/button-api/?text=Spendier mir 'nen Kaffee&emoji=☕&slug=schleishare&button_colour=5F7FFF&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" alt="Spendier mir 'nen Kaffee" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} SchleiShare. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <a href="https://www.instagram.com/schleishare" target="_blank" rel="noopener noreferrer" onClick={() => handleClick('Instagram')} className="text-gray-500 hover:text-white transition-colors" aria-label="SchleiShare auf Instagram"><SafeIcon icon={FiIcons.FiInstagram} className="text-xl" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
